module.exports = __webpack_public_path__ + "img/3bd79b2.png";